
$(document).ready(function () {
    // scroll up js animation start here
        (function ($) {
            $.fn.isOnScreen = function (test) {
                var height = this.outerHeight();
                var width = this.outerWidth();
                if (!width || !height) {
                    return false;
                }
                var win = $(window);
                var viewport = {
                    top: win.scrollTop(),
                    left: win.scrollLeft()
                };
                viewport.right = viewport.left + win.outerWidth();
                viewport.bottom = viewport.top + win.outerHeight() / 1.5;
                var bounds = this.offset();
                bounds.right = bounds.left + width;
                bounds.bottom = bounds.top + height;
                var deltas = {
                    top: viewport.bottom - bounds.top,
                    left: viewport.right - bounds.left,
                    bottom: bounds.bottom - viewport.top,
                    right: bounds.right - viewport.left
                };
                if (typeof test == 'function') {
                    return test.call(this, deltas);
                }
                return deltas.top > 0 && deltas.left > 0 && deltas.right > 0 && deltas.bottom > 0;
            };
        })(jQuery);
    
        $(window).scroll(function () {
            $('.animation-box').each(function () {
                if ($(this).isOnScreen()) {
                    $(this).addClass('onView');
                    var _child = $(this).find('.animation');
                    if (_child.length) {
                        $(function () {
                            var el = _child;
                            var index = 0;
                            var timer = window.setInterval(function () {
                                if (index < el.length) {
                                    el.eq(index++).addClass('onView');
                                } else {
                                    window.clearInterval(timer);
                                }
                            }, 300);
                        });
                    }
                }
            });
        });
    
        $('.animation-box').each(function () {
            if ($(this).isOnScreen()) {
                $(this).addClass('onView');
                var _child = $(this).find('.animation');
                if (_child.length) {
                    $(function () {
                        var el = _child;
                        var index = 0;
                        var timer = window.setInterval(function () {
                            if (index < el.length) {
                                el.eq(index++).addClass('onView');
                            } else {
                                window.clearInterval(timer);
                            }
                        }, 300);
                    });
                }
            }
        });
    });











// $(document).ready(function () {
//   //console.log("Window Width:", $(window).innerWidth());
//   if ($(window).innerWidth() >= 991) {
//     var ctrl = new ScrollMagic.Controller();

//     var t1 = new TimelineMax();
//     t1.from(
//       ".slider_logo_images  ",
//       0.4,
//       { yPercent: 10, opacity: 0, ease: Power1.easeIn },
//       "0"
//     );
//     t1.from(
//       ".slider1_product_image  ",
//       0.4,
//       { yPercent: 10, opacity: 0, ease: Power1.easeIn },
//       "0"
//     );
//     var scene = new ScrollMagic.Scene({
//       triggerElement: ".main-landingPage-slide-1-slide",
//       triggerHook: 0.5,
//       //duration: 500,
//     })
//       .setTween(t1)
//       .addTo(ctrl);

//     var tl = new TimelineMax();
//     tl.from(".main-landingPage-slide-2-slide .slide2-fullwidth_banner", 0.25, {
//       opacity: 0,
//       ease: Power1.easeIn,
//     });
//     tl.to(".main-landingPage-slide-1-slide .slide-fullwidth_banner", 0.25, {
//       opacity: 0,
//       ease: Power1.easeIn,
//     });
//     new ScrollMagic.Scene({
//       triggerElement: ".main-landingPage-slide-2-slide",
//       triggerHook: 0.7,
//       duration: 500,
//     })
//       .setTween(tl)
//       // .addIndicators({
//       //   colorTrigger: "white",
//       //   colorStart: "white",
//       //   colorEnd: "white",
//       //   indent: 40
//       // })
//       .addTo(ctrl);

//     var t2 = new TimelineMax();
//     t2.from(".main-landingPage-slide-3-slide .slide2-fullwidth_banner", 0.25, {
//       opacity: 0,
//       ease: Power1.easeIn,
//     });
//     t2.to(".main-landingPage-slide-2-slide .slide2-fullwidth_banner", 0.25, {
//       opacity: 0.5,
//       ease: Power1.easeIn,
//     });

//     new ScrollMagic.Scene({
//       triggerElement: ".main-landingPage-slide-3-slide",
//       triggerHook: 0.6,
//       duration: 500,
//     })
//       .setTween(t2)
//       // .addIndicators({
//       //   colorTrigger: "white",
//       //   colorStart: "white",
//       //   colorEnd: "white",
//       //   indent: 40
//       // })
//       .addTo(ctrl);

//     window.addEventListener("scroll", function () {
//       var scrollTop = window.scrollY;
//       var opacity = 1 - scrollTop / 500; // Adjust the division factor as needed
//       var opacity2 = 1 - (scrollTop - 800) / 800; // Adjust the division factor as needed

//       // console.log(scrollTop);

//       document.querySelector(".main-landingPage-slide-1-slide").style.opacity =
//         opacity;
//       document.querySelector(".main-landingPage-slide-2-slide").style.opacity =
//         opacity2;
//     });
//   }
// });
